module.exports = __webpack_public_path__ + "static/media/arrow-stroke.c9df4438.svg";